import _ from 'lodash';
import { VueSlideToggle } from 'vue-slide-toggle';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { resolveProductImage, routeToProduct } from '@/helpers';
import IconChevronDown from '@/components/icons/IconChevronDown.vue';
import IconDiscount from '@/components/icons/IconDiscount.vue';
import IconCertificateAmount from '@/components/icons/IconCertificateAmount.vue';

const DeliveryType = {
  PICKUP: 'pickup',
  STORAGE: 'storage',
  ADDRESS: 'address',
  COURIER: 'courier'
};
export default {
  name: 'OrderCard',
  components: {
    IconCertificateAmount,
    IconDiscount,
    IconChevronDown,
    VueSlideToggle
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    isProfessionalOrder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false
    };
  },

  created() {
    if (this.$route.query.order) {
      if (this.data.id == this.$route.query.order) {
        this.isOpen = true;
        this.$nextTick(() => {
          let scrollOptions = {
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          };

          this.$el.scrollIntoView(scrollOptions);
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      repeatProducts: 'order/repeatProducts',
      isDistributor: 'profile/isDistributor',
      isProfessional: 'profile/isProfessional',
      user: 'profile/user'
    })
  },
  methods: {
    resolveProductImage,
    routeToProduct,
    ...mapActions({
      repeatOrder: `order/REPEAT_ORDER`
    }),
    ...mapMutations({
      resetBasket: `basket/RESET_BASKET`,
      addToBasket: `basket/ADD_ITEM_TO_BASKET`
    }),
    /**
     * @param {DeliveryMethod} delivery
     * @return {string|null}
     */
    getTitleForDeliveryInList(delivery) {
      if (!delivery) {
        return null;
      }

      if (delivery.type === DeliveryType.PICKUP) return this.$t('label.free');
      if (delivery.type === DeliveryType.STORAGE) return this.$t('deliveries.accordingToTheCarrierTariffs');
      if (delivery.type === DeliveryType.ADDRESS) return this.$t('deliveries.accordingToTheCarrierTariffs');
      if (delivery.type === DeliveryType.COURIER) return '200' + this.$t('label.grn');

      if (delivery.price <= 0) return '';

      return delivery.price + ' ' + this.$t('label.grn');
    },
    onCopyToClipboard(value) {
      const textarea = document.createElement('textarea');
      textarea.value = value;

      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 99999);
      document.execCommand('copy');
      this.$toasted.success('Номер TTH успішно скопійовано');
      document.body.removeChild(textarea);
    },
    async onRepeatOrder() {
      await this.repeatOrder(this.data.id);

      await this.resetBasket();

      _.each(this.repeatProducts, (repeatProduct) => {
        this.addToBasket({
          select_count: repeatProduct.selectCount,
          product_price: repeatProduct.productPrice,
          product: repeatProduct.product
        });
      });

      this.$router.push({ name: 'buy-flow-basket' }).catch(() => {});
    }
  }
};
